<template>
  <div>
    <div style="padding: 14px;">
      <div class="ellipsis">
        instanceId:
        <span :title="item.instanceId">{{item.instanceId}}</span>
      </div>
      <div class="ellipsis">
        nodeId:
        <span :title="item.nodeId">{{item.nodeId}}</span>
      </div>

      <div class="ellipsis">
        IP:
        <span :title="item.ip">{{item.ip}}</span>
      </div>
      <div class="ellipsis">
        端口号:
        <span :title="item.port">{{item.port}}</span>
      </div>
      <div class="ellipsis">
        模块类型:
        <span :title="item.moduleType">{{item.moduleType}}</span>
      </div>
      <div class="ellipsis">
        服务名称:
        <span :title="item.serviceName">{{item.serviceName}}</span>
      </div>
      <div class="ellipsis">
        地域:
        <span :title="item.area">{{item.area}}</span>
      </div>
      <div class="ellipsis">
        机房:
        <span :title="item.room">{{item.room}}</span>
      </div>
      <div class="ellipsis">
        上线:
        <template :title="item.Online">
          <span v-if="item.Online==true">是</span>
          <span v-if="item.Online==false">否</span>
        </template>
      </div>
      <div class="ellipsis">
        <div v-if="item.active==false" style="background-color: red">
          <span>启动:</span>
          <template :title="item.active">
            <span v-if="item.active==true">是</span>
            <span v-if="item.active==false">否</span>
          </template>
        </div>
        <div v-else>
          <span>启动:</span>
          <template :title="item.active">
            <span v-if="item.active==true">是</span>
            <span v-if="item.active==false">否</span>
          </template>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
  export default {
    name: 'InstanceComponent',
    props: {
      item: {
        type: Object,
        required: true,
        default: {}
      }
    }
  }
</script>
<style scoped>
  .ellipsis {
    /* display: inline; */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
